import { useAuth0 } from '@auth0/auth0-react'
import { useState } from 'react'

export default function Debug() {
  const { getAccessTokenSilently, user } = useAuth0()
  const [token, setToken] = useState<string>('')
  const [tokenClaims, setTokenClaims] = useState<Record<string, unknown> | null>(null)

  const getToken = async () => {
    try {
      const audience = import.meta.env.VITE_AUTH0_AUDIENCE
      console.log('Requesting token with audience:', audience)

      const accessToken = await getAccessTokenSilently({
        authorizationParams: {
          audience: audience
        }
      })

      setToken(accessToken)

      // Decode JWT to see claims (just for debugging)
      const parts = accessToken.split('.')
      if (parts.length === 3) {
        const payload = JSON.parse(atob(parts[1]))
        setTokenClaims(payload)
        console.log('Token claims:', payload)
      }
    } catch (error) {
      console.error('Failed to get token:', error)
      alert('Failed to get token: ' + (error as Error).message)
    }
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-4">Auth Debug</h1>

      <div className="card mb-4">
        <h2 className="font-semibold mb-2">User Info</h2>
        <pre className="bg-gray-100 p-2 rounded text-xs overflow-auto">
          {JSON.stringify(user, null, 2)}
        </pre>
      </div>

      <div className="card mb-4">
        <h2 className="font-semibold mb-2">Environment Variables</h2>
        <pre className="bg-gray-100 p-2 rounded text-xs">
          VITE_AUTH0_DOMAIN: {import.meta.env.VITE_AUTH0_DOMAIN}{'\n'}
          VITE_AUTH0_CLIENT_ID: {import.meta.env.VITE_AUTH0_CLIENT_ID}{'\n'}
          VITE_AUTH0_AUDIENCE: {import.meta.env.VITE_AUTH0_AUDIENCE}{'\n'}
          VITE_API_URL: {import.meta.env.VITE_API_URL}
        </pre>
      </div>

      <button onClick={getToken} className="btn-primary mb-4">
        Get Access Token
      </button>

      {token && (
        <>
          <div className="card mb-4">
            <h2 className="font-semibold mb-2">Access Token</h2>
            <textarea
              className="w-full h-32 bg-gray-100 p-2 rounded text-xs font-mono"
              value={token}
              readOnly
            />
          </div>

          {tokenClaims && (
            <div className="card">
              <h2 className="font-semibold mb-2">Token Claims</h2>
              <pre className="bg-gray-100 p-2 rounded text-xs overflow-auto">
                {JSON.stringify(tokenClaims, null, 2)}
              </pre>
            </div>
          )}
        </>
      )}
    </div>
  )
}
